
export default () => window.CONFIG || {sources: {}}